export default __webpack_public_path__ + "static/media/gallery-05.7ed35076.jpg";